import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const trustSignals = [
    {
      icon: 'Shield',
      title: 'GDPR Compliant',
      description: 'Uw gegevens zijn veilig volgens Europese wetgeving'
    },
    {
      icon: 'Lock',
      title: 'SSL Beveiligd',
      description: 'Versleutelde verbinding voor maximale veiligheid'
    },
    {
      icon: 'Award',
      title: 'KvK Geregistreerd',
      description: 'Officieel geregistreerd Nederlandse onderneming'
    },
    {
      icon: 'Leaf',
      title: 'Duurzaam Gecertificeerd',
      description: 'Erkende groene oplossingen en partners'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-1 p-6 border border-border">
      <div className="text-center mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          Veilig & Betrouwbaar
        </h3>
        <p className="text-sm font-body text-muted-foreground">
          Uw vertrouwen is onze prioriteit
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {trustSignals?.map((signal, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name={signal?.icon} size={16} color="var(--color-success)" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-heading font-medium text-foreground mb-1">
                {signal?.title}
              </h4>
              <p className="text-xs font-body text-muted-foreground">
                {signal?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-center space-x-4 text-xs font-caption text-muted-foreground">
          <span>🇳🇱 Nederlandse Service</span>
          <span>•</span>
          <span>24/7 Klantenservice</span>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;